import { ChevronLeft, ChevronRight } from "lucide-react";

const PAGE_SIZES = [10, 25, 50];

const paginasVisibles = (page, totalPages) => {
  if (totalPages <= 5) return Array.from({ length: totalPages }, (_, index) => index + 1);
  const inicio = Math.min(Math.max(page - 2, 1), totalPages - 4);
  return Array.from({ length: 5 }, (_, index) => inicio + index);
};

export default function Pagination({
  page,
  pageSize,
  totalItems,
  totalPages,
  onPageChange,
  onPageSizeChange,
}) {
  if (totalItems <= 0) return null;
  const desde = (page - 1) * pageSize + 1;
  const hasta = Math.min(page * pageSize, totalItems);

  return (
    <div className="pagination" aria-label="Paginacion del listado">
      <div className="pagination-summary">
        Mostrando <strong>{desde}-{hasta}</strong> de <strong>{totalItems}</strong>
      </div>
      <div className="pagination-controls">
        <label className="pagination-size">
          <span>Filas</span>
          <select value={pageSize} onChange={(event) => onPageSizeChange(event.target.value)}>
            {PAGE_SIZES.map((size) => <option key={size} value={size}>{size}</option>)}
          </select>
        </label>
        <button
          className="btn action-icon-button pagination-arrow"
          type="button"
          title="Pagina anterior"
          aria-label="Pagina anterior"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeft size={17} />
        </button>
        <div className="pagination-pages">
          {paginasVisibles(page, totalPages).map((pageNumber) => (
            <button
              className={`pagination-page${pageNumber === page ? " is-active" : ""}`}
              type="button"
              key={pageNumber}
              aria-label={`Pagina ${pageNumber}`}
              aria-current={pageNumber === page ? "page" : undefined}
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber}
            </button>
          ))}
        </div>
        <button
          className="btn action-icon-button pagination-arrow"
          type="button"
          title="Pagina siguiente"
          aria-label="Pagina siguiente"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          <ChevronRight size={17} />
        </button>
      </div>
    </div>
  );
}
